import { render } from "./AudiovisualChannelView.vue?vue&type=template&id=6ad7e9d4&scoped=true"
import script from "./AudiovisualChannelView.vue?vue&type=script&lang=js"
export * from "./AudiovisualChannelView.vue?vue&type=script&lang=js"

import "./AudiovisualChannelView.vue?vue&type=style&index=0&id=6ad7e9d4&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ad7e9d4"]])

export default __exports__